<div class="product-specifications">
  <h1 class="ui-heading-1-bold product-specifications-title">
    {{ section() }}
  </h1>

  <dl class="product-specifications-content">
    @if (approvalStatus()) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">Approval status</dt>
        <dd class="value ui-body-l">
          {{ approvalStatus() }}
        </dd>
      </div>
    }
    @if (licenseCostResponsibility()) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">License cost responsibility</dt>
        <dd class="value ui-body-l">
          {{ licenseCostResponsibility() }}
        </dd>
      </div>
    }
    @if (developmentCostResponsibility()) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">Development cost responsibility</dt>
        <dd class="value ui-body-l">
          {{ developmentCostResponsibility() }}
        </dd>
      </div>
    }
    @if (developmentCostResponsibilityOtherDetails()) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">Other development cost details</dt>
        <dd class="value ui-body-l">
          {{ developmentCostResponsibilityOtherDetails() }}
        </dd>
      </div>
    }
    @if (supportMaintenanceCostResponsibility()) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">
          Support & maintenance cost responsibility
        </dt>
        <dd class="value ui-body-l">
          {{ supportMaintenanceCostResponsibility() }}
        </dd>
      </div>
    }
    @if (supportMaintenanceCostResponsibilityOtherDetails()) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">
          Other support & maintenance cost details
        </dt>
        <dd class="value ui-body-l">
          {{ supportMaintenanceCostResponsibilityOtherDetails() }}
        </dd>
      </div>
    }
    @if (isPerUserPricingAvailable() != null) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">Pricing per user</dt>
        <dd class="value ui-body-l">
          {{ isPerUserPricingAvailable() ? "Available" : "Not available" }}
        </dd>
      </div>
    }
    @if (
      perUserCostValue() && perUserCostCurrency() && perUserCostFrequency()
    ) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">Cost</dt>
        <dd class="value ui-body-l">
          {{
            perUserCostValue() +
              " " +
              perUserCostCurrency() +
              " / " +
              perUserCostFrequency()
          }}
        </dd>
      </div>
    }
    @if (additionalCostConsiderations()) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">Additional cost considerations</dt>
        <dd class="value ui-body-l">
          {{ additionalCostConsiderations() }}
        </dd>
      </div>
    }
    @if (otherPricingModels()) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">Other pricing models</dt>
        <dd class="value ui-body-l">
          {{ otherPricingModels() }}
        </dd>
      </div>
    }
    @if (systemRiskAssessmentName()) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">System Risk Assessment (SRA)</dt>
        <dd class="value ui-body-l">
          {{ systemRiskAssessmentName() }}
        </dd>
      </div>
    }
    @if (systemRiskAssessmentForSolutions() != null) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">
          System Risk Assessment for Solutions
        </dt>
        <dd class="value ui-body-l">
          {{ systemRiskAssessmentForSolutions() ? "Yes" : "No" }}
        </dd>
      </div>
    }
    @if (classificationLevel()) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">Data confidentiality level</dt>
        <dd class="value ui-body-l">{{ classificationLevel() }}</dd>
      </div>
    }
    @if (classificationRetentionPeriod()) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">Retention period</dt>
        <dd class="value ui-body-l">{{ classificationRetentionPeriod() }}</dd>
      </div>
    }
    @if (supportedDataClassificationLevel()) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">Supported data classification</dt>
        <dd class="value ui-body-l">
          {{ supportedDataClassificationLevel() }}
        </dd>
      </div>
    }
    @if (gxp() != null) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">GxP</dt>
        <dd class="value ui-body-l">{{ gxp() ? 'Yes' : 'No' }}</dd>
      </div>
    }
    @if (hosting()) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">Hosting provider name</dt>
        <dd class="value ui-body-l">
          @for (host of hosting(); track $index) {
            {{ host.name }}
            @if (!$last) {
              ,
            }
          }
        </dd>
      </div>
    }
    @if (hosting()) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">Hosting type</dt>
        <dd class="value ui-body-l">
          @for (host of hosting(); track $index) {
            {{ host.type }} ({{ host.managed }})
            @if (!$last) {
              ,
            }
          }
        </dd>
      </div>
    }
    @if (singleSignOnIsSupported() != null) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">Single sign-on support</dt>
        <dd class="value ui-body-l">
          {{ singleSignOnIsSupported() ? "Available" : "Not available" }}
        </dd>
      </div>
    }
    @if (singleSignOnProviders()?.length > 0) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">Single sign-on providers</dt>
        <dd class="value ui-body-l">
          {{ singleSignOnProviders().join(", ") }}
        </dd>
      </div>
    }
    @if (isSupported() != null) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">Support available</dt>
        <dd class="value ui-body-l">
          {{ isSupported() ? "Yes" : "No" }}
        </dd>
      </div>
    }
    @if (agentName()) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">AI Agent name</dt>
        <dd class="value ui-body-l">
          <a [href]="agentUrl()" target="_blank">{{ agentName() }} </a>
        </dd>
      </div>
    }
    @if (isExternalUseAllowed() != null) {
      <div class="product-secifications-item">
        <dt class="label ui-body-l-bold">External use</dt>
        <dd class="value ui-body-l">
          {{ isExternalUseAllowed() ? "Yes" : "No" }}
        </dd>
      </div>
    }
  </dl>
</div>
